import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "device-list-container" }
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = { class: "header-top" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "device-list" }
const _hoisted_6 = { class: "status-col" }
const _hoisted_7 = { class: "info-col" }
const _hoisted_8 = { class: "vin" }
const _hoisted_9 = { class: "code" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "actions-col" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "sidebar-calendar-popover"
}

import { computed, ref } from 'vue';
import { NavigationIcon, MapPinIcon, MapIcon, ActivityIcon, XIcon, CalendarIcon } from 'lucide-vue-next';
import MaterialCalendar from '../ui/MaterialCalendar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceList',
  props: {
    devices: {},
    activeTrackId: {}
  },
  emits: ['center', 'toggle-track', 'close', 'date-select'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Calendar State
const showCalendar = ref(false);
const calendarDeviceId = ref<number | string | null>(null);
const selectedDateVal = ref(new Date().toISOString().split('T')[0]);

const sortedDevices = computed(() => {
    return [...props.devices].sort((a, b) => {
        return (a.vin || '').localeCompare(b.vin || '');
    });
});

function isMoving(device: any): boolean {
    const speed = parseFloat(device.latest_data?.vehicle_speed || '0');
    return speed > 0;
}

function getStatusClass(device: any) {
    return isMoving(device) ? 'moving' : 'stopped';
}

function formatTime(ts: string | number) {
    if (!ts) return '--:--';
    let time = Number(ts);
    if (String(ts).length === 10) time *= 1000; 
    
    const d = new Date(time);
    if (isNaN(d.getTime())) return '--:--';
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function toggleCalendar(devId: number | string) {
    if (calendarDeviceId.value === devId && showCalendar.value) {
        closeCalendar();
    } else {
        calendarDeviceId.value = devId;
        showCalendar.value = true;
    }
}

function closeCalendar() {
    showCalendar.value = false;
    calendarDeviceId.value = null;
}

function onDateSelected(date: string) {
    if (calendarDeviceId.value) {
        emit('date-select', { deviceId: calendarDeviceId.value, date });
        closeCalendar();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.devices.length) + " Mezzi", 1),
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_unref(XIcon), { size: 20 })
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-cols" }, [
        _createElementVNode("span", null, "Stato"),
        _createElementVNode("span", null, "VIN / Codice"),
        _createElementVNode("span", null, "Azioni")
      ], -1))
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedDevices.value, (device) => {
        return (_openBlock(), _createElementBlock("li", {
          key: device.id,
          class: "device-item"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["status-icon", getStatusClass(device)])
            }, [
              (isMoving(device))
                ? (_openBlock(), _createBlock(_unref(NavigationIcon), {
                    key: 0,
                    class: "ico-move"
                  }))
                : (_openBlock(), _createBlock(_unref(MapPinIcon), {
                    key: 1,
                    class: "ico-stop"
                  }))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(device.vin || device.name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(device.serial || device.id), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(formatTime(device.latest_data?.timestamp || device.updatedAt)), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass(["action-btn", { active: calendarDeviceId.value === device.id }]),
              title: "Seleziona data",
              onClick: _withModifiers(($event: any) => (toggleCalendar(device.id)), ["stop"])
            }, [
              _createVNode(_unref(CalendarIcon), { size: 16 })
            ], 10, _hoisted_12),
            _createElementVNode("button", {
              class: "action-btn",
              title: "Centra in mappa",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('center', device)), ["stop"])
            }, [
              _createVNode(_unref(MapIcon), { size: 16 })
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              class: _normalizeClass(["action-btn", { active: __props.activeTrackId === device.id }]),
              title: "Mostra tracciato",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('toggle-track', device)), ["stop"])
            }, [
              _createVNode(_unref(ActivityIcon), { size: 16 })
            ], 10, _hoisted_14)
          ])
        ]))
      }), 128))
    ]),
    (showCalendar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", { class: "calendar-header" }, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Seleziona Data", -1)),
            _createElementVNode("button", {
              class: "close-cal-btn",
              onClick: closeCalendar
            }, "✕")
          ]),
          _createVNode(MaterialCalendar, {
            modelValue: selectedDateVal.value,
            activityDates: [],
            "onUpdate:modelValue": onDateSelected
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})